




































import { QBtn } from 'quasar'
import ArticleTable from 'src/components/ArticleTable.vue'
import UploadArticleModal from 'src/components/UploadArticleModal.vue'
import downloadCsv from 'src/domains/file/download-file'
import { IArticle, readArticles } from 'src/store/article'
import { Component, Vue } from 'vue-property-decorator'
import { IVxsPromise, vxsActionFetch, vxsDataGetter } from 'vuex-xhr-state'

@Component({
  components: { ArticleTable, UploadArticleModal, QBtn },
})

export default class Articles extends Vue {
  @vxsDataGetter(readArticles) private readArticles!: () => IArticle[]
  @vxsActionFetch(readArticles) private fetchArticles!: () => IVxsPromise<IArticle[]>

  public uploadModalOpen = false

  public created(): void {
    this.fetchArticles()
  }

  get articles(): IArticle[] {
    return this.readArticles()
  }

  public openUploadModal(): void {
    this.uploadModalOpen = true
  }

  public exportData(url: string, fileName: string): void {
    downloadCsv(url, fileName)
  }
}
